import { Box, CircularProgress, Typography } from "@mui/material";
import React from "react";

const CircleView = ({
  variant = "info",
  value = 0,
  innerRadius = 70,
  outerRadius = 80,
}) => {
  return (
    <Box sx={{ position: "relative" }}>
      <Box
        sx={{
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: outerRadius,
        }}
      >
        <CircularProgress
          variant="determinate"
          value={100}
          size={innerRadius}
          thickness={4}
          sx={{
            color: (theme) => theme.palette[variant]?.main,
            position: "absolute",
          }}
        />
        <CircularProgress
          variant="determinate"
          value={100}
          size={outerRadius}
          thickness={4}
          sx={{
            color: (theme) => theme.palette.background[variant],
            position: "absolute",
          }}
        />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="h6">
            {value !== null && value !== undefined ? Math.round(value) : "-"}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default CircleView;
